import { baseUrl, handleResponse, handleError, PostOptions, GetHeaders } from "../../../../apis/common/ApiUtils";

const apiUrl = baseUrl + "travel/onetimeexpense";

// Employees eligible for a one-time expense on the given AP account
// (active, holding at least one voucher on that AP account).
export function getExpenseEligibleEmployees(apAccountId) {
    return fetch(`${apiUrl}/eligible-employees?apAccountId=${apAccountId}`, GetHeaders())
        .then(handleResponse)
        .catch(handleError);
}

// Apply a one-time expense to one or more employees on an AP account.
// request: { apAccountId, expenseDate, description, entries: [{ employeeId, amount }] }
export function applyOneTimeExpense(request) {
    return fetch(`${apiUrl}`, PostOptions(request))
        .then(handleResponse)
        .catch(handleError);
}
